export default __webpack_public_path__ + "static/media/ngo-a035-4.d31b95db.jpg";